package com.dignicate.web.data.markdown.parser.handlers

import com.dignicate.web.data.markdown.model.MarkdownBlock
import com.dignicate.web.data.markdown.parser.core.MarkdownHandler
import com.dignicate.web.data.markdown.parser.core.ParsingContext

class UnorderedListHandler : MarkdownHandler {

    private val prefixes = listOf("- ", "* ")

    override fun canHandle(ctx: ParsingContext): Boolean {
        return ctx.currentLineStartsWith(prefixes)
    }

    override fun handle(ctx: ParsingContext) {
        val itemsRaw = generateSequence {
            if (ctx.currentLineStartsWith(prefixes)) {
                ctx.currentLine()?.also { ctx.index++ }
            } else {
                null
            }
        }.map { it.drop(2) }.toList()

        val items = itemsRaw.map(InlineLinkParser::parseLinkOrText)
        ctx.blocks.add(MarkdownBlock.UnorderedList(items))
    }
}

private fun ParsingContext.currentLineStartsWith(prefixes: List<String>): Boolean {
    val line = currentLine() ?: return false
    return prefixes.any { line.startsWith(it) }
}
